import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const fishHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "topfish",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
